'use client';

import React from 'react';
import { useAuthorization } from 'lib/authorization';
import { motion } from 'framer-motion';

export const SecureText = ({
  value = '',
  allowedRoles = [],
  requiredPermissions = [],
  className = '',
}) => {
  const { checkRoleAccess, checkPermissions } = useAuthorization();

  const isAuthorized =
    checkRoleAccess(allowedRoles) && checkPermissions(requiredPermissions);

  const lineCount = 20;

  const lines = Array.from({ length: lineCount }, (_, i) => {
    const height = `${Math.floor(Math.random() * 1) + 1}ch`;

    return (
      <motion.div
        key={i}
        className="w-1 rounded-full bg-white/60"
        style={{ height }}
        animate={{
          y: ['0%', '-20%', '10%', '0%'],
        }}
        transition={{
          duration: 2 + Math.random() * 2,
          repeat: Infinity,
          ease: 'easeInOut',
          delay: Math.random(),
        }}
      />
    );
  });

  return (
    <span className={`relative inline-block font-mono text-white ${className}`}>
      <span className="opacity-0 select-none">{value}</span>

      {!isAuthorized && (
        <div className="absolute w-40 inset-0 z-10 overflow-hidden group">
          {/* Animated up-down line mask */}
          <div className="absolute inset-0 flex items-center justify-start space-x-[2px] px-1">
            {lines}
          </div>

          {/* Hover "Redacted" overlay */}
          <div className="absolute inset-0 z-20 rounded-xl bg-black/80 backdrop-blur-sm flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
            <span className="text-xs tracking-widest text-white/60">
              Redacted
            </span>
          </div>
        </div>
      )}

      {isAuthorized && (
        <span className="absolute inset-0 z-20 text-white">{value}</span>
      )}
    </span>
  );
};
